import { render } from "./create-control.vue?vue&type=template&id=67ed86ec&scoped=true&ts=true"
import script from "./create-control.vue?vue&type=script&lang=ts"
export * from "./create-control.vue?vue&type=script&lang=ts"

import "./create-control.vue?vue&type=style&index=0&id=67ed86ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ed86ec"]])

export default __exports__